<template>
  <div class="statistics-container">
    <!-- 顶部诊所信息 -->
    <div class="clinic-header">
      <div class="clinic-image-section">
        <div class="clinic-image-upload">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="handleAvatarUpload">
            
            <div class="upload-placeholder">
              <i class="el-icon-plus"></i>
              <span>上传诊所图片</span>
            </div>
          </el-upload>
        </div>
      </div>
      <div class="clinic-info-section">
        <div class="clinic-main-info">
          <h2 class="clinic-name">{{ clinicName }}</h2>
          <div class="user-info">
            <!-- <span class="separator">></span> -->
            <span class="user-name">{{ currentUser.name }}</span>
            <span class="separator">|</span>
            <span class="user-phone">{{ currentUser.phone }}</span>
          </div>
        </div>
        <div class="clinic-expiry-info">
          <span class="expiry-text">当前诊所有效期至</span>
          <span class="expiry-date">{{ expiryDate }}</span>
        </div>
      </div>
    </div>

    <!-- 角色权限区域 -->
    <div class="role-permission-section">
      <div class="section-title">
        <h3>角色权限</h3>
        <p class="section-desc">当前系统角色：展示当前诊所所拥有的角色</p>
      </div>
      <div class="permission-content">
        <el-checkbox-group v-model="checkedRoles">
          <el-checkbox 
            v-for="role in roleList" 
            :key="role.id" 
            :label="role.roleName"
            class="role-checkbox">
            {{ role.roleName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 统计图表区域 -->
    <div class="statistics-section">
      <!-- 西药统计 -->
      <div class="chart-container">
        <div class="chart-header">
          <h3 class="chart-title">西药统计</h3>
        </div>
        <div class="chart-content">
          <div class="pie-chart">
            <div class="chart-wrapper">
              <div id="westernPieChart" class="chart"></div>
            </div>
            <div class="chart-legend">
              <div class="legend-title">医生姓名统计</div>
              <div class="legend-items">
                <div v-for="item in westernPieData" :key="item.name" class="legend-item">
                  <span class="legend-color" :style="{backgroundColor: item.color}"></span>
                  <span class="legend-name">{{ item.name }}</span>
                  <span class="legend-value">{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bar-chart">
            <div class="chart-wrapper">
              <div id="westernBarChart" class="chart"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中药统计 -->
      <div class="chart-container">
        <div class="chart-header">
          <h3 class="chart-title">中药统计</h3>
        </div>
        <div class="chart-content">
          <div class="pie-chart">
            <div class="chart-wrapper">
              <div id="chinesePieChart" class="chart"></div>
            </div>
            <div class="chart-legend">
              <div class="legend-title">医生姓名统计</div>
              <div class="legend-items">
                <div v-for="item in chinesePieData" :key="item.name" class="legend-item">
                  <span class="legend-color" :style="{backgroundColor: item.color}"></span>
                  <span class="legend-name">{{ item.name }}</span>
                  <span class="legend-value">{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bar-chart">
            <div class="chart-wrapper">
              <div id="chineseBarChart" class="chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getAllRole } from "@/api/user.js";

export default {
  name: 'MedicineStatistics',
  data() {
    return {
      clinicImage: '',
      clinicName: '',
      expiryDate: '2024-12-31',
      currentUser: {
        name: '',
        phone: ''
      },
      checkedRoles: [],
      roleList: [],
      // 西药统计数据
      westernPieData: [
        { name: '张培东', value: 1.5, color: '#5470c6' },
        { name: '陈南', value: 0.5, color: '#91cc75' },
        { name: '杨世江', value: 1.5, color: '#fac858' },
        { name: '吴笙榕', value: 0.5, color: '#ee6666' },
        { name: '杜作强', value: 0.5, color: '#73c0de' },
        { name: '陈科均', value: 0.5, color: '#3ba272' },
        { name: '王耀萱', value: 1.5, color: '#fc8452' }
      ],
      // 中药统计数据
      chinesePieData: [
        { name: '张培东', value: 1.5, color: '#5470c6' },
        { name: '陈南', value: 1.0, color: '#91cc75' },
        { name: '杨世江', value: 2.0, color: '#fac858' },
        { name: '吴笙榕', value: 0.8, color: '#ee6666' },
        { name: '杜作强', value: 1.5, color: '#73c0de' },
        { name: '陈科均', value: 1.2, color: '#3ba272' },
        { name: '王耀萱', value: 0.9, color: '#fc8452' }
      ],
      westernPieChart: null,
      westernBarChart: null,
      chinesePieChart: null,
      chineseBarChart: null
    }
  },
  mounted() {
    this.initUserInfo();
    this.loadRoleList();
    this.initCharts();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.disposeCharts();
  },
  methods: {
    // 初始化用户信息
    initUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          console.log('用户信息:', userInfo);
          
          // 设置诊所名称
          this.clinicName = userInfo.clinicName || '未命名诊所';
          
          // 设置用户信息
          this.currentUser.name = userInfo.staffName || '未知用户';
          this.currentUser.phone = userInfo.mobile || '暂无联系方式';
          
          // 设置有效期（如果有的话）
          if (userInfo.expiryDate) {
            this.expiryDate = userInfo.expiryDate;
          }
        } else {
          this.clinicName = '默认诊所';
          this.currentUser.name = '默认用户';
          this.currentUser.phone = '暂无联系方式';
          console.warn('未找到用户信息，使用默认值');
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
        this.clinicName = '错误诊所';
        this.currentUser.name = '错误用户';
        this.currentUser.phone = '错误联系方式';
      }
    },

    // 加载角色列表
    async loadRoleList() {
      try {
        const response = await getAllRole();
        if (response.code === 200) {
          this.roleList = response.data.content || response.rows || [];
          console.log('角色列表加载成功:', this.roleList);
        } else {
          console.error('获取角色列表失败:', response.message);
          this.roleList = [];
        }
      } catch (error) {
        console.error('调用角色接口失败:', error);
        this.roleList = [];
      }
    },

    // 初始化图表
    initCharts() {
      this.$nextTick(() => {
        this.initWesternPieChart();
        this.initWesternBarChart();
        this.initChinesePieChart();
        this.initChineseBarChart();
      });
    },

    // 初始化西药饼图
    initWesternPieChart() {
      const chartDom = document.getElementById('westernPieChart');
      if (!chartDom) return;
      
      this.westernPieChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '报名统计（饼图按专业）',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: '西药统计',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            data: this.westernPieData.map(item => ({
              name: item.name,
              value: item.value
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {c}'
            }
          }
        ],
        color: this.westernPieData.map(item => item.color)
      };
      this.westernPieChart.setOption(option);
    },

    // 初始化西药柱状图
    initWesternBarChart() {
      const chartDom = document.getElementById('westernBarChart');
      if (!chartDom) return;
      
      this.westernBarChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '医生姓名统计',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.westernPieData.map(item => item.name),
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '数量'
        },
        series: [
          {
            name: '西药统计',
            type: 'bar',
            data: this.westernPieData.map(item => item.value),
            itemStyle: {
              color: '#5470c6'
            }
          }
        ]
      };
      this.westernBarChart.setOption(option);
    },

    // 初始化中药饼图
    initChinesePieChart() {
      const chartDom = document.getElementById('chinesePieChart');
      if (!chartDom) return;
      
      this.chinesePieChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '报名统计（饼图按专业）',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: '中药统计',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            data: this.chinesePieData.map(item => ({
              name: item.name,
              value: item.value
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {c}'
            }
          }
        ],
        color: this.chinesePieData.map(item => item.color)
      };
      this.chinesePieChart.setOption(option);
    },

    // 初始化中药柱状图
    initChineseBarChart() {
      const chartDom = document.getElementById('chineseBarChart');
      if (!chartDom) return;
      
      this.chineseBarChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '医生姓名统计',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.chinesePieData.map(item => item.name),
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '数量'
        },
        series: [
          {
            name: '中药统计',
            type: 'bar',
            data: this.chinesePieData.map(item => item.value),
            itemStyle: {
              color: '#91cc75'
            }
          }
        ]
      };
      this.chineseBarChart.setOption(option);
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.westernPieChart) this.westernPieChart.resize();
      if (this.westernBarChart) this.westernBarChart.resize();
      if (this.chinesePieChart) this.chinesePieChart.resize();
      if (this.chineseBarChart) this.chineseBarChart.resize();
    },

    // 销毁图表实例
    disposeCharts() {
      if (this.westernPieChart) this.westernPieChart.dispose();
      if (this.westernBarChart) this.westernBarChart.dispose();
      if (this.chinesePieChart) this.chinesePieChart.dispose();
      if (this.chineseBarChart) this.chineseBarChart.dispose();
    },

    // 图片上传前验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 处理图片上传
    handleAvatarUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.clinicImage = e.target.result;
        this.$message.success('诊所图片上传成功');
      };
      reader.readAsDataURL(file.file);
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

// 顶部诊所信息
.clinic-header {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  gap: 20px;

  .clinic-image-section {
    flex-shrink: 0;
    
    .clinic-image-upload {
      .avatar-uploader {
        /deep/ .el-upload {
          border: 2px dashed #dcdfe6;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          width: 120px;
          height: 120px;
          
          &:hover {
            border-color: #409eff;
          }
        }
        
        .clinic-avatar {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }
        
        .upload-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #8c939d;
          
          i {
            font-size: 28px;
            margin-bottom: 8px;
          }
          
          span {
            font-size: 12px;
          }
        }
      }
    }
  }

  .clinic-info-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    .clinic-main-info {
      .clinic-name {
        margin: 0 0 8px 0;
        font-size: 24px;
        color: #303133;
        font-weight: 600;
      }
      
      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #606266;
        
        .separator {
          color: #dcdfe6;
        }
        
        .user-name {
          font-weight: 500;
          color: #409eff;
        }
        
        .user-phone {
          color: #67c23a;
        }
      }
    }
    
    .clinic-expiry-info {
      padding: 8px 12px;
      background: #f0f9ff;
      border-radius: 4px;
      border-left: 4px solid #409eff;
      
      .expiry-text {
        font-size: 13px;
        color: #606266;
        margin-right: 8px;
      }
      
      .expiry-date {
        font-size: 13px;
        color: #e6a23c;
        font-weight: 600;
      }
    }
  }
}

// 角色权限区域
.role-permission-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .section-title {
    margin-bottom: 20px;
    
    h3 {
      margin: 0 0 8px 0;
      font-size: 18px;
      color: #303133;
      font-weight: 600;
    }
    
    .section-desc {
      margin: 0;
      font-size: 14px;
      color: #909399;
    }
  }

  .permission-content {
    .role-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      
      /deep/ .el-checkbox__label {
        font-size: 14px;
      }
    }
  }
}

// 统计图表区域
.statistics-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
  gap: 20px;

  .chart-container {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .chart-header {
      margin-bottom: 20px;
      
      .chart-title {
        margin: 0;
        font-size: 18px;
        color: #303133;
        font-weight: 600;
        text-align: center;
      }
    }

    .chart-content {
      display: flex;
      gap: 20px;
      min-height: 400px;

      .pie-chart {
        flex: 1;
        display: flex;
        gap: 20px;
        
        .chart-wrapper {
          flex: 2;
          min-height: 300px;
          
          .chart {
            width: 100%;
            height: 100%;
            min-height: 300px;
          }
        }
        
        .chart-legend {
          flex: 1;
          padding: 10px;
          border: 1px solid #e8e8e8;
          border-radius: 4px;
          
          .legend-title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
            color: #303133;
            text-align: center;
          }
          
          .legend-items {
            .legend-item {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              font-size: 12px;
              
              .legend-color {
                width: 12px;
                height: 12px;
                border-radius: 2px;
                margin-right: 8px;
              }
              
              .legend-name {
                flex: 1;
                color: #606266;
              }
              
              .legend-value {
                color: #909399;
                font-weight: 500;
              }
            }
          }
        }
      }

      .bar-chart {
        flex: 1;
        
        .chart-wrapper {
          width: 100%;
          height: 100%;
          min-height: 300px;
          
          .chart {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .statistics-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .statistics-container {
    padding: 10px;
  }

  .clinic-header {
    flex-direction: column;
    text-align: center;
    gap: 15px;
    
    .clinic-info-section {
      .clinic-main-info {
        .user-info {
          justify-content: center;
        }
      }
    }
  }

  .chart-content {
    flex-direction: column !important;
    
    .pie-chart {
      flex-direction: column !important;
    }
  }

  .role-permission-section {
    .permission-content {
      .role-checkbox {
        display: block;
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 480px) {
  .statistics-section {
    grid-template-columns: 1fr;
    
    .chart-container {
      padding: 10px;
    }
  }
  
  .clinic-header {
    .clinic-info-section {
      .clinic-main-info {
        .clinic-name {
          font-size: 20px;
        }
        
        .user-info {
          flex-direction: column;
          gap: 4px;
          
          .separator {
            display: none;
          }
        }
      }
    }
  }
}
</style>